import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'How long does setup take?',
  answer: 'Most users are up and running in under 5 minutes. The dashboard comes with a simple setup guide — just enter your products, costs, and platform details. No formulas to write, no complicated configuration.'
}, {
  question: 'Does it work with both Google Sheets and Excel?',
  answer: 'Yes! You get both versions included. Use whichever you prefer — Google Sheets for cloud access from any device, or Excel for offline use. Both versions have identical features.'
}, {
  question: 'Which e-commerce platforms does it support?',
  answer: 'The dashboard works with Shopify, Etsy, Amazon, WooCommerce, and any other platform where you sell products. You manually enter your data (or copy-paste from exports), so it works universally.'
}, {
  question: 'How do I get my files after purchase?',
  answer: "Instantly! After checkout, you'll receive a download link on the confirmation page and via email. Click to download your Google Sheets and Excel files immediately. No waiting."
}, {
  question: "What if it doesn't work for my business?",
  answer: "We offer a full 30-day money-back guarantee. If the dashboard doesn't help you understand your numbers better, just email us and we'll refund every penny. No questions asked."
}, {
  question: 'Do I need a paid Google account?',
  answer: "No! Google Sheets is completely free with any Google account (even a free Gmail). You don't need Google Workspace or any paid subscription. For Excel, you just need any version of Microsoft Excel."
}];
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="border-b border-gray-200" data-id="element-73">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between py-5 text-left group" aria-expanded={open} data-id="element-74">
        <span className="font-display font-semibold text-base text-gray-900 pr-4 group-hover:text-[#0084A8] transition-colors" data-id="element-75">
          {question}
        </span>
        <motion.div animate={{
        rotate: open ? 180 : 0
      }} transition={{
        duration: 0.25
      }} className="flex-shrink-0" data-id="element-76">
          <ChevronDownIcon className="w-5 h-5 text-gray-400" data-id="element-77" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-78">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="overflow-hidden" data-id="element-79">
            <p className="text-gray-500 text-sm leading-relaxed pb-5" data-id="element-80">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  return <section id="faq" className="bg-white py-20" data-id="element-81">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-83">
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-gray-900" data-id="element-84">
            Frequently Asked Questions
          </h2>
        </motion.div>

        <div data-id="element-85">
          {faqs.map(faq => <FAQItem key={faq.question} question={faq.question} answer={faq.answer} data-id="element-86" />)}
        </div>
      </div>
    </section>;
}